import * as React from "react";
import { forwardRef } from "react";
const SvgItalic = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-italic-icon lucide-italic", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("line", { x1: 19, x2: 10, y1: 4, y2: 4 }), /* @__PURE__ */ React.createElement("line", { x1: 14, x2: 5, y1: 20, y2: 20 }), /* @__PURE__ */ React.createElement("line", { x1: 15, x2: 9, y1: 4, y2: 20 }));
const ForwardRef = forwardRef(SvgItalic);
export default ForwardRef;
